import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faFacebookF, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { trackOutboundLink } from "../utils/analytics";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-6 lg:px-16">
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="text-3xl font-bold mb-3 text-green-400">EcoRide</h3>
            <p className="text-sm text-gray-400 leading-relaxed max-w-xs">
              Private birding tours, eco-friendly adventures, and sustainable travel experiences across Costa Rica.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-3 text-green-400">Explore</h4>
            <nav aria-label="Footer navigation">
              <ul className="space-y-2 text-sm text-gray-400">
                <li><Link to="/birding" onClick={scrollToTop} className="hover:text-white transition-colors">Birding Tours</Link></li>
                <li><Link to="/itinerary" onClick={scrollToTop} className="hover:text-white transition-colors">Sample 7-Day Itinerary</Link></li>
                <li><Link to="/lodge" onClick={scrollToTop} className="hover:text-white transition-colors">Birding Lodge</Link></li>
                <li><Link to="/services" onClick={scrollToTop} className="hover:text-white transition-colors">Local Tours</Link></li>
                <li><Link to="/wildlife" onClick={scrollToTop} className="hover:text-white transition-colors">Wildlife Directory</Link></li>
                <li><Link to="/transport" onClick={scrollToTop} className="hover:text-white transition-colors">Transportation</Link></li>
                <li><Link to="/guide" onClick={scrollToTop} className="hover:text-white transition-colors">Meet Your Guide</Link></li>
                <li><Link to="/contact" onClick={scrollToTop} className="hover:text-white transition-colors">Contact Us</Link></li>
              </ul>
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-3 text-green-400">Contact</h4>
            <div className="space-y-2 text-sm text-gray-400">
              <p>
                <a href="mailto:michael@ecoride.cr" className="hover:text-white transition-colors">
                  michael@ecoride.cr
                </a>
              </p>
              <p>
                <a href="tel:+50685499997" className="hover:text-white transition-colors">
                  +506 8549 9997
                </a>
              </p>
              <p>Alajuela, Costa Rica</p>
              <p>Mon - Sun: 6:00 AM - 5:00 PM</p>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-700 my-6"></div>

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          {/* Social Media Links */}
          <div className="flex items-center gap-4">
            <span className="text-sm text-gray-400">Follow Us</span>
            <a
              href="https://www.instagram.com/ecoridecosta/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Follow EcoRide on Instagram"
              onClick={() => trackOutboundLink('https://www.instagram.com/ecoridecosta/', 'Instagram')}
              className="rounded-full p-2.5 flex items-center justify-center transition-transform duration-300 ease-in-out hover:scale-110"
              style={{
                background: "linear-gradient(45deg, #f09433 0%, #e6683c 40%, #dc2743 60%, #cc2366 80%, #bc1888 100%)",
              }}
            >
              <FontAwesomeIcon icon={faInstagram} size="lg" style={{ color: "#ffffff" }} />
            </a>
            <a
              href="https://www.facebook.com/jimenez.segura"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Follow EcoRide on Facebook"
              onClick={() => trackOutboundLink('https://www.facebook.com/jimenez.segura', 'Facebook')}
              className="bg-[#4267B2] rounded-full p-2.5 flex items-center justify-center transition-transform duration-300 ease-in-out hover:scale-110"
            >
              <FontAwesomeIcon icon={faFacebookF} size="lg" className="text-white" />
            </a>
            <a
              href="https://wa.me/50685499997"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Contact EcoRide on WhatsApp"
              onClick={() => trackOutboundLink('https://wa.me/50685499997', 'WhatsApp')}
              className="rounded-full p-2.5 flex items-center justify-center transition-transform duration-300 ease-in-out hover:scale-110"
              style={{ backgroundColor: "#25D366" }}
            >
              <FontAwesomeIcon icon={faWhatsapp} size="lg" style={{ color: "#ffffff" }} />
            </a>
          </div>

          {/* Copyright */}
          <p className="text-sm text-gray-500 text-center">
            &copy; {currentYear} EcoRide Costa Rica. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
